import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');

let port = parseInt(atob(document.querySelector('meta[name="wsp"]').content));
let isLocalDev = port > 1000;

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: atob(document.querySelector('meta[name="ws"]').content),
    wsHost: atob(document.querySelector('meta[name="wsh"]').content),
    wssHost: atob(document.querySelector('meta[name="wsh"]').content),
    wsPort: isLocalDev ? 6001 : 80,
    wssPort: isLocalDev ? 6001 : 443,
    disableStats: true,
    forceTLS: !isLocalDev,
    enabledTransports: ['ws', 'wss'],
});
